/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import 'firebase/auth';
import 'firebase/firestore';
import { Menu } from 'antd';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { auth } from '../../../utils/firebase';
import { logoutUser } from '../../../_actions/userActions';

function RightMenu(props) {
  const dispatch = useDispatch();

  const isLogin = useSelector((state) => state.user.isLogin);

  const logoutHandler = () => {
    auth.signOut();
    dispatch(logoutUser());
    localStorage.removeItem('u_id');
    props.history.push('/');
    window.location.reload();
  };

  const renderMenu = () => {
    if (isLogin) {
      return (
        <Menu mode={props.mode}>
          <Menu.Item key='home'>
            <a href='/'>홈</a>
          </Menu.Item>
          <Menu.Item key='cart'>
            <a href='/cart'>짤주머니</a>
          </Menu.Item>
          <Menu.Item key='logout'>
            <a onClick={logoutHandler}>로그아웃</a>
          </Menu.Item>
        </Menu>
      );
    } else {
      return (
        <Menu mode={props.mode}>
          <Menu.Item key='home'>
            <a href='/'>홈</a>
          </Menu.Item>
          <Menu.Item key='mail'>
            <a href='/login'>로그인</a>
          </Menu.Item>
        </Menu>
      );
    }
  };

  return <>{renderMenu()}</>;
}

export default withRouter(RightMenu);
